import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import StyledFormTitle from '../styles/form-title';
import GlobalUserSyncTool from './GlobalUserSyncTool';

export interface SuperAdminToolsProps {

}

const Title = styled(StyledFormTitle)`
    margin-bottom: 1rem;
`;

const Subheader = styled.div`
    color: ${(props) => props.theme.colors.secondary.main};
    margin-bottom: 2rem;
`;

const StyledFormGroupContainer = styled.div`
    margin-left: 2rem;
    margin-bottom: 1rem;
`;

const SuperAdminTools: React.FC<SuperAdminToolsProps> = () => {
    const { t } = useTranslation('admin_settings');

    return (
        <>
            <Title>{t('navigationTabs.super-admin-tools')}</Title>
            <Subheader>{t('super-admin-warning')}</Subheader>

            <StyledFormGroupContainer>
                <GlobalUserSyncTool />

            </StyledFormGroupContainer>
        </>
    );
}

export default SuperAdminTools;
